import { LOG_ATTRIBUTION, LANUCH_MOBILE_CONFIG } from "../constants/path";
import http from "../base";
import PresisiteAPIParams from "../persisits/lunch_params";
import {
  INS_API_ATTRIBUTION,
  INS_API_MOBILE_CONFIG
} from "../constants/event_consts";
import { cg_api_signed_body } from "../utils/index";

export async function logAttribution() {
  return new Promise((resolve, reject) => {
    const body: Record<string, string> = {};
    body.type = "app_first_launch";
    body.adid = "";
    http
      .post(
        LOG_ATTRIBUTION,
        {
          data: body
        },
        {},
        INS_API_ATTRIBUTION
      )
      .then(res => {
        console.log("LOG_ATTRIBUTION res", res);
        resolve(res);
      })
      .catch(err => {
        console.log("LOG_ATTRIBUTION err", err);
        resolve(err);
      });
  });
}

export async function mobileconfig(
  user_id: string = "",
  not_show_veify: boolean = false
) {
  console.log("mobileconfig userid", user_id);
  const body: Record<string, string> = {};
  body.fetch_type = "ASYNC_FULL";
  body.device_id = await PresisiteAPIParams.getAPIId("cg_api_device_id");
  body.bool_opt_policy = "0";
  body.api_version = "3";
  if (!user_id) {
    body.unit_type = "1";
    body.query_hash =
      "733ac26cbdef049d38a5e43feea309b430ae226ffdc531febca771e525d2e684";
    const ts = await PresisiteAPIParams.getConfigTs();
    ts && (body.ts = ts);
  } else {
    body.unit_type = "2";
    body._uid = user_id || "";
    body._uuid = await PresisiteAPIParams.getAPIId("cg_api_device_id");
    body.query_hash =
      "7d7af0cbd214d906fe970a2b61ff58098cbe8bb81a3778c41436d7b75b1fd70f";
  }
  const signData = cg_api_signed_body(body);

  try {
    const data = await http.post(
      LANUCH_MOBILE_CONFIG,
      {
        data: signData
      },
      {
        user_id,
        not_show_veify
      },
      INS_API_MOBILE_CONFIG
    );
    if (data.ts) {
      PresisiteAPIParams.catchConfigTs(data.ts);
    }
    return true;
  } catch (error) {
    console.log("mobileconfig error", error);
  }
}
